<p-iconfield class="block w-full" iconPosition="right">
  <input
    type="text"
    pInputText
    class="w-100"
    [placeholder]="placeholder()"
    [(ngModel)]="searchValue"
    (ngModelChange)="onSearchValueChange($event)"
  />
  <p-inputicon class="pi pi-search"></p-inputicon>
</p-iconfield>
